import { useConfiguration } from '@/parts/configuration/wrapper'
import { useBooleanFlagValue } from '@openfeature/react-sdk'
import { useRouter } from '@/parts/router/query-preserving'
import { useStudent } from '@/parts/student/hook'
import { useEffect } from 'react'
import { trackTimeOnTaskPath } from './tracker'

export default function TrackTimeOnTask() {
  const { loginUrl, timeOnTaskUrl } = useConfiguration()
  const isEnabled = useBooleanFlagValue('msp_time-on-task-v2', false)
  const { asPath } = useRouter()
  const { id: studentId } = useStudent()

  useEffect(() => {
    if (!isEnabled) return

    void trackTimeOnTaskPath({
      loginUrl,
      path: asPath,
      studentId,
      timeOnTaskUrl,
    })
  }, [asPath, isEnabled, loginUrl, studentId, timeOnTaskUrl])

  return null
}
